<template>
    <div class="train-settings">
        <div class="train-settings__top"></div>

        <div class="train-settings__card">
            <div class="train-settings__title">
                Favoriten
            </div>

            <div class="train-settings__list">
                <div class="train-item"
                     v-for="item in favtrains"
                     :key="item.id"
                     @click="removeTrain(item.id)"
                >
                    <i class="train-item__icon material-icons">remove_circle</i>
                    <div class="train-item__name">
                        {{item.train}}
                    </div>
                </div>
            </div>

            <div class="train-settings__separator"></div>

            <div class="train-settings__list">
                <div class="train-item"
                     v-for="item in allTrains"
                     :key="item.id"
                     @click="addTrain(item.id,item.train)"
                >
                    <i class="train-item__icon material-icons">add_circle</i>
                    <div class="train-item__name">
                        {{item.train}}
                    </div>
                </div>
            </div>

            <default-button @click="saveFav">
                Speichern
            </default-button>
        </div>
    </div>
</template>

<script>

import DefaultButton from '../common/default-button';
export default {
    components: { DefaultButton },
    data() {
        return {}
    },
    computed: {
        allTrains() {
            return this.$store.getters['fotodatenbank/trains'];
        },
        favtrains() {
            return this.$store.getters['user/favtrains'];
        }

    },
    methods: {
        addTrain(id, train) {
            this.$store.dispatch('user/addfavtrains', { id: id, train: train });
        },
        removeTrain(id) {
            this.$store.dispatch('user/removefavtrain', { id: id });
        },
        saveFav() {
            this.$store.dispatch('user/saveFavTrains');
        }

    },
    created() {
        this.$store.dispatch('fotodatenbank/trains');
        this.$store.dispatch('user/getFavTrains');
    }
}
</script>

<style scoped lang="scss">
    .train-settings__title {
        position: relative;
        font-size: 2rem;
        padding-left: 1rem;
        padding-right: 1rem;
        background-color: $color-gray;
        color: $color-white;
    }

    .train-settings {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100vh;
        background-color: $color-white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .train-settings__card {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100vh;
    }

    .train-settings__top {
        height: 70px;
    }

    .train-settings__list {
        flex: 1;
        overflow-y: auto;
        width: 100%;
    }

    .train-settings__separator {
        /*margin-top: 1rem;*/
        /*margin-bottom: 1rem;*/
        height: 1px;
        background-color: $color-list-hover;
    }

    .train-item__icon {
        font-size: 2rem;
        display: inline-block;
    }

    .train-item__name {
        display: inline-block;

    }

    .train-item {
        font-size: 2rem;
        width: 100%;
        padding: 0.375rem;
        cursor: pointer;

        &:hover {
            background-color: $color-list-hover;
        }
    }

    @include medium {
        .train-settings__top {
            display: none;
        }

        .train-settings__card {
            width: 31rem;
            @include default-shadow;
        }
    }

    @include extra-large {
        .train-settings__card {
            width: 31rem;
            @include default-shadow;
            height: 80vh;
        }
    }

</style>
